import React from 'react'
import { isEmpty } from 'lodash'
import CatalogTaxonomyStatusLine from '../CatalogTaxonomyStatusLine'
import styles from './CatalogTaxonomyArchiveSection.module.scss'

function CatalogTaxonomyArchiveSection({ nodes = [], selectedId = '', onSelect, ancestors = [] }) {
  const [isExpanded, setIsExpanded] = React.useState(false)

  if (isEmpty(nodes)) {
    return null
  }

  return (
    <div className={styles.archiveSection}>
      <button
        type="button"
        className={styles.archiveToggle}
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        Архів ({nodes.length})
        <span className={isExpanded ? styles.archiveChevronExpanded : styles.archiveChevron}>▾</span>
      </button>

      {isExpanded && (
        <div className={styles.archiveList}>
          {nodes.map((node) => {
            const className = [
              styles.item,
              `${selectedId}` === `${node.id}` ? styles.itemSelected : '',
              styles.itemArchived,
            ]
              .filter(Boolean)
              .join(' ')

            return (
              <div key={node.id} className={className} onClick={() => onSelect(node.id)}>
                <p className={styles.itemTitle}>{node.name || '—'}</p>
                <CatalogTaxonomyStatusLine node={node} ancestors={ancestors} />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default CatalogTaxonomyArchiveSection
